import moment from 'moment';

export default class AppService
{
	constructor(DateRangeService)
	{
		this.dateRange = DateRangeService;
		this.period = 'day';
		this.limit = false;
		this.loader = false;
		this.compare = 0;
		this.page = null;
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/services/app.service.js
 **/